export const ForeignFlightTicketIssuer = {
  tsd: 'ティ・エス・ディ',
  tabikobo: '旅工房'
} as const;

export type ForeignFlightTicketIssuerKey = keyof typeof ForeignFlightTicketIssuer;

export const ForeignFlightTicketIssuerKeys: readonly ForeignFlightTicketIssuerKey[] = ['tsd', 'tabikobo'];
